// extracted by mini-css-extract-plugin
export var bgImg = "landingPage-module--bgImg--a0ee1";
export var clipHorizontalOverflow = "landingPage-module--clipHorizontalOverflow--c305d";
export var ctaSection = "landingPage-module--ctaSection--3150a";
export var exploreMangomint = "landingPage-module--exploreMangomint--dd278";
export var logoSoup = "landingPage-module--logoSoup--184ce";
export var pageHeader = "landingPage-module--pageHeader--d2b0c";
export var pageWrapper = "landingPage-module--page-wrapper--ff49e";
export var pulse = "landingPage-module--pulse--0fd76";
export var sections = "landingPage-module--sections--9d22f";
export var wistiaEmbed = "landingPage-module--wistia-embed--df10b";